module.exports = __webpack_public_path__ + "img/special_fog.388c8bc6.png";